import { ISharedItemProvider } from "@/Portal/Services/ISharedItemProvider";

class GrowthChartSharedItemProvider implements ISharedItemProvider {
    public getSharedItemTypeLabel(): string {
        return cacheStore.GetString("GrowthChartsLabel");
    }

    public getItemIconClass(): string {
        return "growthChartsIcon";
    }

    public shouldShowFilePreviewInPortfolio(): boolean {
        return true;
    }

    public createSendMedicalNoteItemToPortalPopupStrategy(): null {
        return null;
    }

    public getPinFrequencyToken(): string {
        return "";
    }

    public getPinFrequencyDocumentType(): null {
        return null;
    }
}

export { GrowthChartSharedItemProvider };
